import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderIconButton from "./HeaderIconButton";

import { makeStyles } from '@material-ui/core';

const styles = makeStyles(theme => ({
	icon: {
		width: "1em !important",
		color: theme.palette.text.primary
	},

	label: {
		justifyContent: "flex-start"
	}
}));

function BackButton(props) {
	const onClick = (event) => {
		if(!props.backUrl) {
			props.history.goBack();
		} else {
			props.history.push(props.backUrl);
		}
	};

	let classes = styles(),
		{backUrl} = props,
		icon = (
			<FontAwesomeIcon
				icon={["far", "long-arrow-left"]}
				className={classes.icon}
				title="back button" />
		);

	return (
		<React.Fragment>
			<HeaderIconButton
				handleClick={onClick}
				classOverrides={{
					label: classes.label
				}}>
				{backUrl ?
					<Link
						to={backUrl}
						replace
						arial-label="back button">{icon}
					</Link>
					:
					icon
				}
			</HeaderIconButton>
		</React.Fragment>
	);
}

BackButton.propTypes = {
	history: PropTypes.object.isRequired,
	backUrl: PropTypes.string
};

export default withRouter(BackButton);
